<template>
<div class="over">
    <Header title="申请退款" />
    <div class="scrollerView">
        <div v-if="dataSources.status === 'REFUND'" class="type" @click="onPressNav('refundRecord', {order_id, order_no})">
            <img class="icon" :src="Images.icon_refund" alt="">
            <div>
                <p>查看</p>
                <span>本单退款记录</span>
            </div>
            <img class="arrow" :src="Images.icon_arrow_right2" alt="">
        </div>
        <div v-else class="type" @click="onPressNav('refundRecord', {order_id, order_no})">
            <img class="icon" :src="Images.icon_refund" alt="">
            <div>
                <p>退款</p>
                <span>填写退款信息</span>
            </div>
        </div>
        <div v-if="dataSources.status !== 'REFUND'" class="card">
            <div @click="isShowRefundType = true">
                <p>退款类型</p>
                <span class="cus-select-item">{{refund_reason || '请选择'}}</span>
            </div>
            <!-- <div>
                <p>退款原因</p>
                <input placeholder="请填写退款原因" type="text" v-model="refund_reason">
            </div> -->
            <div>
                <p>所属商城</p>
                <span>{{dataSources.company_name}}</span>
            </div>
        </div>
        <div class="goods">
            <p>可退商品</p>
            <div v-for="(item, index) in dataSources.order_detail" :key="index">
                <div v-if="!item.check && (dataSources.status !== 'REFUND' || dataSources.is_refund == 3)" class="un-check" @click="onPressCheck(true, index)"></div>
                <div v-if="item.check && (dataSources.status !== 'REFUND' || dataSources.is_refund == 3)" class="check" @click="onPressCheck(false, index)">
                    <img :src="Images.icon_check" alt="">
                </div>
                <div class="body">
                    <img :src="item.goods_image" alt="">
                    <div>
                        <p class="title">{{item.goods_name}}</p>
                        <p class="unit">规格:{{item.sku_field_name}}</p>
                        <div class="price">
                            <p>￥{{item.payment}}</p>
                            <van-stepper v-model="item.cur_qty" :max="item.cur_qty" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="dataSources.status !== 'REFUND' || dataSources.is_refund == 3" class="card">
            <div class="textarea noline">
                <p>补充描述</p>
                <textarea rows="3" cols="20" placeholder="请填写补充描述" v-model="refund_desc"></textarea>
            </div>
        </div>
    </div>
    <div v-if="dataSources.status !== 'REFUND' || dataSources.is_refund == 3" class="footer" @click="onPressRefund">提交</div>

    <van-action-sheet description="退款原因" v-model="isShowRefundType" :actions="refund_type" @select="_onSelectRefundType" cancel-text="取消" />
</div>
</template>

<script>
import Header from '@/components/Header'
export default {
    components: {
        'Header': Header,
    },
    data() {
        return {
            wrapperHeight: 0, //屏幕高度 - 脚部
            order_id: this.$route.query.order_id,
            order_no: this.$route.query.order_no,
            isShowRefundType: false,
            dataSources: {},
            refund_type: [],
            refund_reason: '',
            refund_desc: '',
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
        this.requestRefundType();
    },
    methods: {
        // -------------------------------------------------- request  --------------------------------------------------
        async requestRefundType() {
            let url = this.API.shop_refund_reason;
            let params = {};
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.refund_type = result.data;
            }
        },
        async requestData() {
            let url = this.API.shop_order_detail;
            let params = {
                is_refund_detail: 1,
                order_no: this.order_no,
            };
            let result = await this.$post(url, params);

            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                if (result.data.is_refund && result.data.is_refund > 0) {
                    result.data.status = 'REFUND'
                }
                this.dataSources = result.data;
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // -------------------------------------------------- onPress  --------------------------------------------------
        // 点击跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        },
        // 点击选择商品
        onPressCheck(val, index) {
            let array = this.dataSources.order_detail.slice();
            array[index].check = val
            this.dataSources.order_detail = array;
        },
        _onSelectRefundType(action, index) {
            console.log('action, index---->', action, index);
            this.refund_reason = action.name;
            this.isShowRefundType = false;
        },
        // 点击售后
        onPressRefund() {
            this.$dialog.confirm({
                    title: '温馨提示',
                    message: '您的操作即将申请退款！',
                })
                .then(() => {
                    this.refund();
                })
                .catch(() => {
                    this.Message({
                        title: "已取消"
                    });
                });
        },
        // 售后
        async refund() {
            let goods_list = [];
            this.dataSources.order_detail.forEach(element => {
                element.check && goods_list.push({
                    goods_id: element.goods_id,
                    num: element.cur_qty,
                    price: element.payment,
                    order_detail_id: element.id,
                })
            });
            if (goods_list.length === 0) {
                this.Message({
                    title: "请选择需要退款的商品"
                });
                return
            }
            let url = this.API.shop_apply_order_refund;
            let params = {
                order_no: this.dataSources.order_no,
                goods_info: JSON.stringify(goods_list),
                // goods_info: goods_list,
                refund_reason: this.refund_reason,
                refund_desc: this.refund_desc,
            };
            let result = await this.$post(url, params);

            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.$router.go(-1);
                // wxPay(pay_config, (res) => {
                //     if (res.type == 'success') {
                //         this.timer_pay && clearTimeout(this.timer_pay)
                //         this.timer_pay = setTimeout(() => {
                //         this.checkPaySuccess()
                //         }, 2000)
                //     }
                // })
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.type {
    margin: 10px 15px 0;
    padding: 0 15px;
    height: 72px;
    display: flex;
    align-items: center;
    background-image: url('../../assets/img/img_btn_bg1.png');
    background-size: cover;

    >.icon {
        width: 30px;
        height: 30px;
        object-fit: contain;
    }

    >div {
        flex: 1;
        margin: 0 10px;
        display: flex;
        flex-direction: column;

        >p {
            margin-bottom: 5px;
            font-size: 15px;
            color: #fff;
        }

        >span {
            font-size: 13px;
            color: #fff;
        }
    }

    >.arrow {
        width: 8px;
        height: 15px;
    }
}

.card {
    margin: 10px 15px 0;
    padding: 0 10px;
    background: #fff;

    >div {
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;

        p {
            flex: 1;
            height: 50px;
            font-size: 14px;
            color: #666666;
            line-height: 50px;
        }

        span {
            font-size: 14px;
            color: #333;
        }

        img {
            width: 6px;
            height: 12px;
            margin-left: 10px;
        }

        input {
            text-align: right;
            font-size: 14px;
            color: #333;
        }
    }

    .textarea {
        padding-bottom: 10px;
        flex-direction: column;
        align-items: flex-start;

        textarea {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            border-width: 0px;
            background: #F8F8F8;
            resize: none;
            font-size: 14px;
            color: #333;
        }
    }

    .noline {
        border-bottom: 0px;
    }
}

.goods {
    margin: 10px 15px 0;
    padding: 0 10px 10px;
    background: #fff;

    >p {
        padding-top: 10px;
        font-size: 14px;
        color: #333;
    }

    >div {
        margin: 10px 0 0;
        display: flex;
        align-items: center;

        .check {
            width: 18px;
            height: 18px;
            margin-right: 5px;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .un-check {
            width: 16px;
            height: 16px;
            margin-right: 5px;
            border-radius: 50%;
            border: 1px solid #999;
        }

        .body {
            flex: 1;
            display: flex;

            >img {
                width: 80px;
                height: 80px;
                object-fit: cover;
                margin-right: 10px;
            }

            >div {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                overflow: hidden;

                .title {
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                .unit {
                    font-size: 12px;
                    color: #666666;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .price {
                    display: flex;
                    align-items: center;

                    p {
                        flex: 1;
                        font-size: 14px;
                        color: #EF1400;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    span {
                        font-size: 13px;
                        color: #333;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}

.footer {
    height: 40px;
    margin: 10px 15px;
    background: linear-gradient(225deg, #9cb2f4, #6472e8);
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #fff;
}
</style>
